import React from "react";

const Store = (props) => (

  <div className="sideNavSection">
    <div className="feature">
      <h3>Out now on Dream Chimney</h3>
      {/* <p style={{ fontSize: 14 }}> Personal System 個人システム "Distant Paradise"</p>
      <a href="https://dreamchimney.bandcamp.com/album/distant-paradise" target="_blank">
        <img src="https://www.dreamchimney.com/releases/DC015/DC015_tape_bg_300.png" className="img-responsive center-block" alt="Distant Paradise" />
        <div className="featureTextFooter">
          <strong>Available now on Digital &amp; Cassette &raquo;</strong>
        </div>
      </a> */}
      <p style={{ fontSize: 18, marginTop: 4, marginBottom: 10 }}><strong>Sim Fossil "Side Order"</strong></p>
      <p style={{ fontSize: 14 }}>
        Sim Fossil returns to the label with a sharper, dancefloor-ready focus bridging the space between low-BPM proto-house, NuBeat, and Balearic techno.
      </p>
      <a href="https://dreamchimney.bandcamp.com/album/side-order" target="_blank" onClick={() => window.gtag('event', 'totd_click', { eventLabel: `Tracks Right Nav: Sim Fossil Side Order` })}>
        <img src="https://f4.bcbits.com/img/a1475975696_1x1_700.avif" className="img-responsive center-block" alt="Sim Fossil / Side Order" />
        <div className="featureTextFooter">
          <strong>Available now &raquo;</strong>
        </div>
      </a>
    </div>
  </div>

);

export default Store;
